export default __webpack_public_path__ + "static/media/dashboard 1.e427669d.svg";